const doc = [({"da":({"js":({"admin":({"activity_surveys":({"table":({"replies":"Besvarelser"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;